import { render } from "./StockBarang.vue?vue&type=template&id=672b761a&scoped=true"
import script from "./StockBarang.vue?vue&type=script&lang=js"
export * from "./StockBarang.vue?vue&type=script&lang=js"

import "./StockBarang.vue?vue&type=style&index=0&id=672b761a&scoped=true&lang=css"
import "./StockBarang.vue?vue&type=style&index=1&id=672b761a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\INVENTORY BCK\\inventoryfe_bck\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672b761a"]])

export default __exports__